import React, { useState, useEffect } from 'react';
import { Row, Col, Card, Form, Button, Spinner, Alert } from 'react-bootstrap';
import { store } from '../../../../store/store';
import ManagerSubscriptionsApiClient from '../../../../api-client/ManagerSubscriptionsApiClient';

const ManagerSubscriptionsSettings = () => {
    const [settings, setSettings] = useState(null);
    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    const [success, setSuccess] = useState(false);

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        setLoading(true);
        try {
            const token = store.getState().auth.auth.idToken;
            const client = new ManagerSubscriptionsApiClient();
            const data = await client.getAdminSettings(token);
            if (!data.error) {
                // Convert prices from cents to EUR for display
                const displayData = { ...data };
                if (displayData.listPriceEurCents !== undefined) {
                    displayData.listPriceEur = (displayData.listPriceEurCents / 100).toFixed(2);
                }
                if (displayData.discountedPriceEurCents !== undefined) {
                    displayData.discountedPriceEur = (displayData.discountedPriceEurCents / 100).toFixed(2);
                }
                setSettings(displayData);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSettings(prev => ({ ...prev, [name]: value }));
    };

    const handleSave = async (e) => {
        e.preventDefault();
        setSaving(true);
        setError('');
        setSuccess(false);

        try {
            const token = store.getState().auth.auth.idToken;
            const client = new ManagerSubscriptionsApiClient();
            
            const payload = { ...settings };
            
            // Convert EUR to cents
            const listPriceEur = parseFloat(payload.listPriceEur);
            const discountedPriceEur = parseFloat(payload.discountedPriceEur);
            
            payload.listPriceEurCents = isNaN(listPriceEur) ? 0 : Math.round(listPriceEur * 100);
            payload.discountedPriceEurCents = isNaN(discountedPriceEur) ? 0 : Math.round(discountedPriceEur * 100);

            const res = await client.updateAdminSettings(token, payload);
            if (!res.error) {
                setSuccess(true);
                setTimeout(() => setSuccess(false), 3000);
            } else {
                setError(res.error || 'Errore durante il salvataggio');
            }
        } catch (e) {
            setError('Errore di connessione');
        } finally {
            setSaving(false);
        }
    };

    if (loading) {
        return <div className="text-center mt-5"><Spinner animation="border" /></div>;
    }

    if (!settings) {
        return <div className="text-center mt-5">Nessuna impostazione trovata. Configura prima i dati da backend o inserisci dati di default.</div>;
    }

    return (
        <Row>
            <Col lg={12}>
                <Card>
                    <Card.Header>
                        <Card.Title>Impostazioni Abbonamenti Manager</Card.Title>
                    </Card.Header>
                    <Card.Body>
                        {error && <Alert variant="danger">{error}</Alert>}
                        {success && <Alert variant="success">Impostazioni salvate con successo!</Alert>}
                        
                        <Form onSubmit={handleSave}>
                            <h5 className="mb-3">Prezzi e Sconti</h5>
                            <Row>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Prezzo Listino (EUR)</Form.Label>
                                        <Form.Control type="number" step="0.01" name="listPriceEur" value={settings.listPriceEur || ''} onChange={handleChange} />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Codice Sconto Attivo</Form.Label>
                                        <Form.Control type="text" name="discountCode" value={settings.discountCode || ''} onChange={handleChange} />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Prezzo Scontato (EUR)</Form.Label>
                                        <Form.Control type="number" step="0.01" name="discountedPriceEur" value={settings.discountedPriceEur || ''} onChange={handleChange} />
                                    </Form.Group>
                                </Col>
                            </Row>

                            <hr />
                            <h5 className="mb-3 mt-4">Fatturazione SportID (Mittente)</h5>
                            <Row>
                                <Col md={6}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Denominazione</Form.Label>
                                        <Form.Control type="text" name="sportidBillingDenomination" value={settings.sportidBillingDenomination || ''} onChange={handleChange} />
                                    </Form.Group>
                                </Col>
                                <Col md={3}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Partita IVA</Form.Label>
                                        <Form.Control type="text" name="sportidBillingVatNumber" value={settings.sportidBillingVatNumber || ''} onChange={handleChange} />
                                    </Form.Group>
                                </Col>
                                <Col md={3}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Codice Fiscale</Form.Label>
                                        <Form.Control type="text" name="sportidBillingTaxCode" value={settings.sportidBillingTaxCode || ''} onChange={handleChange} />
                                    </Form.Group>
                                </Col>
                                <Col md={12}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Indirizzo</Form.Label>
                                        <Form.Control type="text" name="sportidBillingAddress" value={settings.sportidBillingAddress || ''} onChange={handleChange} />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>CAP</Form.Label>
                                        <Form.Control type="text" name="sportidBillingZipCode" value={settings.sportidBillingZipCode || ''} onChange={handleChange} />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Città</Form.Label>
                                        <Form.Control type="text" name="sportidBillingCity" value={settings.sportidBillingCity || ''} onChange={handleChange} />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Provincia</Form.Label>
                                        <Form.Control type="text" name="sportidBillingProvince" value={settings.sportidBillingProvince || ''} onChange={handleChange} />
                                    </Form.Group>
                                </Col>
                                <Col md={4}>
                                    <Form.Group className="mb-3">
                                        <Form.Label>Regime Fiscale</Form.Label>
                                        <Form.Select name="sportidBillingFiscalRegime" value={settings.sportidBillingFiscalRegime || ''} onChange={handleChange} required>
                                            {/* Senza l'opzione vuota il browser mostrerebbe "Ordinario (RF01)" anche
                                                con il campo non valorizzato, e il valore non verrebbe mai salvato. */}
                                            <option value="">Seleziona regime fiscale...</option>
                                            <option value="RF01">Ordinario (RF01)</option>
                                            <option value="RF02">Contribuenti minimi (RF02)</option>
                                            <option value="RF19">Forfettario (RF19)</option>
                                        </Form.Select>
                                    </Form.Group>
                                </Col>
                            </Row>

                            <Button variant="primary" type="submit" disabled={saving} className="mt-4 w-100">
                                {saving ? 'Salvataggio...' : 'Salva Impostazioni'}
                            </Button>
                        </Form>
                    </Card.Body>
                </Card>
            </Col>
        </Row>
    );
};

export default ManagerSubscriptionsSettings;